import React, { Component } from "react";
import styles from "./Layouts.local.scss";
import { connect } from "react-redux";
import classnames from "classnames";

class CoverSlide extends Component {
  render() {
    const {
      layoutData: { data },
      period,
      currentOrganization
    } = this.props;

    let logo =
      currentOrganization && currentOrganization.avatarUrl
        ? currentOrganization.avatarUrl
        : null;
    let logoBlock = (
      <span
        className={classnames("boxes__box__logo", styles.cover_logo)}
        style={{ backgroundImage: `url(${logo})` }}
      />
    );

    return (
      <div className={styles.cover_content}>
        <div className={styles.cover_bar} />
        <div className={styles.cover_main_title}>
          <div className={styles.cover_title}>Présentation {period}.</div>
          <div className={styles.cover_subtitle}>
            <div className={styles.cover_title_form}>
              {data.organization.legalForm}.
            </div>
            <div className={styles.cover_title_label}>
              {data.organization.name}
            </div>
          </div>
        </div>
        {logoBlock}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  period: state.dashboard.data && state.dashboard.data.period,
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(CoverSlide);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layouts/CoverSlide.js